<template>
  <footer>
    <div class="contenedor footer-contenido bg-blanco">
      <div class="footer-box ubicacion">
          <h3>Ubicación</h3>
          <p>Calzada Zavaleta 2001</p>
          <p>Puebla, Puebla</p>
      </div>
      <div class="footer-box contacto">
          <h3>Contacto</h3>
          <p>Tel: 222-205-1030</p>
          <a href="tel:222-205-1030">Llamar</a>
      </div>
      <div class="footer-box horarios">
          <h3>Horarios</h3>
          <p>Mar-Jue: 11-22</p>
          <p>Vie-Sab: 10-23</p>
          <p>Dom: 12-20</p>
      </div>
    </div>
    <p class="copyright text-center">La Cafetería &copy; Todos los derechos reservados</p>
  </footer>  
</template>

<style scoped>
footer {
  background-color: #5e311e;
  z-index: 3;
  position: relative;
}
footer .copyright {
  margin: 0;
  color: #fff;
  font-family: "Bona Nova", serif;
  padding: 1rem;
}

.footer-contenido {
  padding: 4rem;
}
@media (min-width: 768px) {
  .footer-contenido {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
}

.footer-box {
  font-family: "Bona Nova", serif;
  text-align: center;
}
.footer-box h3 {
  font-family: "Bona Nova", serif;
  font-size: 2.2rem;
  color: #c39c63;
  margin: 2rem 0;
}
.footer-box p, .footer-box a {
  font-size: 1.8rem;
  color: #000;
  line-height: 1;
}
</style>